import React from "react";
import clsx from "clsx";
import DesignEditor from '../DesignEditor';
import CodeEditor from '../CodeEditor';
import Sidebar from "../Sidebar";
import ErrorHelper from "../../Errors/ErrorHelper";

export default class EmailBuilderGeneral extends React.Component{
  constructor(props) {
    super(props);
  }

  render() {
    var tabClasses = clsx({
      'active': this.props.active_tab == 'general',
      'tab-pane': true,
      'row': true
    })

    return (
      <div className={tabClasses} id="general">
        {ErrorHelper.renderErrors(this.props.errors, ['code', 'name', 'time_period', 'from_address', 'to_addresses', 'subject', 'body'])}
        <div className="row" style={{height: '100%'}}>
          <input type="hidden" name="email[editor_type]" value={this.props.email && this.props.email.editor_type ? this.props.email.editor_type : ''} />

          <div className="col-sm-3">
            <Sidebar {...this.props} />
          </div>

          <div className="col-sm-9">
            {this.renderEditor()}
          </div>
        </div>
      </div>
    );
  }

  renderEditor() {
    if (this.props.email && this.props.email.editor_type == 'design') {
      return <DesignEditor {...this.props} onChange={this.props.onEditorChange} images_data_table_path={this.props.paths.images_data_table_path} folio_item_types={this.props.folio_item_types} survey_forms={this.props.survey_forms} document_forms={this.props.document_forms}/>
    } else if (this.props.email && this.props.email.editor_type == 'code') {
      return <CodeEditor {...this.props} onChange={this.props.onEditorChange}/>
    } else {
      return null;
    }
  }
};